import { AlertTriangle } from "lucide-react";
import { AdminModal } from "./AdminModal";
import { CancelButton } from "./PageHeader";
import PennText from "@/components/ui/text/PennText";

type DeleteConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemLabel?: string;
};

export const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  itemLabel = "this record",
}: DeleteConfirmModalProps) => (
  <AdminModal
    open={open}
    onClose={onClose}
    title="Delete record"
    maxWidth="max-w-sm"
    footer={
      <>
        <CancelButton onClick={onClose} />
        <button
          onClick={() => { onConfirm(); onClose(); }}
          className="px-4 py-2 text-button bg-red-600 hover:bg-red-700 active:bg-red-800 text-white rounded-lg shadow-sm shadow-red-200 dark:shadow-red-900/30 transition-all duration-150 cursor-pointer"
        >
          Delete
        </button>
      </>
    }
  >
    <div className="flex gap-4">
      <div className="shrink-0 w-10 h-10 rounded-full bg-red-50 dark:bg-red-950/50 flex items-center justify-center">
        <AlertTriangle size={18} className="text-red-500" />
      </div>
      <div>
        <PennText as="p" size="sm" font="semibold" color="blue_grey1" className="mb-1">
          Are you sure?
        </PennText>
        <PennText as="p" size="sm" color="blue_grey">
          You are about to delete{" "}
          <span className="font-medium text-blue_grey1">{itemLabel}</span>. This action cannot be undone.
        </PennText>
      </div>
    </div>
  </AdminModal>
);
